import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage';
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_SERBIA_Cylindercentre_04 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_04.webp'
import imgHANSA_FLEX__BRANCH_SERBIA_ZELZNIC from '../../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_ZELZNIC.webp'
import imgZelzenik1 from '../../../assets/Branch/Zelzenik/Zelzenik1.jpg';
import imgZelzenik2 from '../../../assets/Branch/Zelzenik/Zelzenik2.jpg';
import imgZelzenik3 from '../../../assets/Branch/Zelzenik/Zelzenik3.jpg';
import imgZelzenik4 from '../../../assets/Branch/Zelzenik/Zelzenik4.jpg';

const Branch5 = () => {
  const data1 = {
    image: imgHANSA_FLEX_SERBIA_Cylindercentre_04,
    title: "Hydraulic cylinder",
    description: "Hydraulic cylinders perform extremely heavy work. As the most important drive elements in hydraulics, they convert the pressure energy of the hydraulic fluid into mechanical energy. Cylinders can transmit very high forces while producing uniform and precise movements. HANSA-FLEX sells a wide range of single- and to double-acting standard cylinders and manufactures customised hydraulic cylinders up to 8,000 mm in height.",
    buttonName: "Learn More",
    buttonLink: "/cylinder",
  }
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);

  const carouselData = [
    {
      image: imgZelzenik1,
    },
    {
      image: imgZelzenik2,
    },
    {
      image: imgZelzenik3,
    },
    {
      image: imgZelzenik4,
    },


  ]




  return (
    <div>
      <CenterStage imageSrc={imgHANSA_FLEX__BRANCH_SERBIA_ZELZNIC} title={"Welcome to HANSA-FLEX Železnik"} paragraph={"Železnik Founded in 2017 in order to allow easier access to the customers from the Belgrade on the right bank of the river Sava, branch Železnik has quickly attracted the customer to whom Zemun was too far away. Similar to other branches, Železnik supplies wide range of customers, from the small services and agricultural manufacturers to the large systems.Regarding it’s territory, the branch covers South-East of the territory of the City of Belgrade (Obrenovac, Lazarevac, Mladenovac), than further accross Smederevo all the way to Negotin and Romanian border on the East and all the way to Zrenjanin on the North."}
        buttonName={"Contact us"} buttonLink={"/contact-us"}
      />

      <ThreeDImageCarousel items={carouselData} />


      <div className="text-center div-gray">
        <SectionHeader
          title={"📞 At Your Service – We're Just a Call Away!"}
          subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
        />
        <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
        <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
        <br /><br /><br />
      </div>



    </div>
  )
}

export default Branch5